import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import moment from "moment"
import React, { useState } from "react"
import { Button } from "react-bootstrap"

import useCallApi from "../../hooks/useCallApi"
import ReportTable from "../../templates/ReportTable/ReportTable"
import Loading from "../../templates/UI/Loading/Loading"
import APIBuilderModal from "../APIBuilderModal/APIBuilderModal"


const APIList = ({ showSystemMessage }) => {
    document.title = 'API List'

    const [isOpen, setIsOpen] = useState(false)
    const [api, setApi] = useState({})
    const { data, dataLoaded, refetch } = useCallApi('apiList', 'GET', {}, [])

    const openAPIModal = () => {
        setIsOpen(true)
    }

    const handleClose = () => {
        setIsOpen(false)
        setApi({})
        refetch()
    }

    const openModal = (api) => {
        setApi(api)
        setIsOpen(true)
    }

    // {
    //     id: 1,
    //     name: 'Test API 1',
    //     endpoint: 'www.testtracking.com/',
    //     map_click_id: '',
    //     map_sale_amount: '',
    //     map_lead_data: '',
    //     map_net_rate: '',
    //     map_commission_rate: '',
    //     map_affiliate_id: '',
    //     map_offer_id: '',
    //     map_api_offer_id: '',
    //     map_ratename: '',
    //     map_transaction_date: '',
    //     map_pages: '20',
    //     map_records_per_page: '',
    //     map_total_records: '',
    //     map_success_key: '',
    //     map_success_value: '',
    //     records_per_page: 50,
    //     credential1: 'admin',
    //     credential2: 'admin',
    //     credential3: '0',
    //     start_date: 2024-12-26T00:00:00.000Z,
    //     interval_type: '0',
    //     interval_value: 0,
    //     split_subid_delimiter: ' ',
    //     status: 'A'
    //   }

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Actions',
                accessor: 'actions',
                Cell: (tableData) => {
                    return <>
                        <Button size="sm" variant="link" style={{ color: "orange" }} onClick={() => openModal(tableData.row.original)}>
                            <FontAwesomeIcon icon="pencil-alt" />
                        </Button>
                    </>
                }
            },
            {
                Header: 'Name',
                accessor: 'name',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                }
            },
            {
                Header: 'Status',
                accessor: 'status',
                Cell: ({ cell: { value } }) => {
                    return <>{value === 'A' ? 'Active' : value === 'T' ? 'Testing' : 'Cancelled'}</>
                }
            },
            {
                Header: 'Start Date',
                accessor: 'start_date',
                Cell: ({ cell: { value } }) => {
                    return moment(value).utc().format('YYYY/MM/DD hh:mm:ss A')
                }
            },
            {
                Header: 'Interval',
                accessor: 'interval_type',
                Cell: (tableData) => {
                    return `Every ${tableData.row.original.interval_value} ${tableData.row.original.interval_type}`
                }
            },
            {
                Header: 'Last Run',
                accessor: 'last_run_date',
                Cell: ({ cell: { value } }) => {
                    return moment(value).utc().format('YYYY/MM/DD hh:mm:ss A')
                }
            },
            {
                Header: 'Next Run',
                accessor: 'next_run_date',
                Cell: ({ cell: { value } }) => {
                    return moment(value).utc().format('YYYY/MM/DD hh:mm:ss A')
                }
            }
        ]

        return (
            <React.Fragment>
                <ReportTable data={data.api_list} columns={columns} />
            </React.Fragment>
        )
    }

    return (
        <div>
            {isOpen && <APIBuilderModal showSystemMessage={showSystemMessage} isOpen={isOpen} handleClose={handleClose} api={api} />}
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">API Manager</h1>
            </div>
            <div className="card">
                <div className="card-body p-0">
                    <div className="d-flex align-items-center justify-content-between p-2">
                        <h1 className="mb-h1-dark">API List</h1>
                        <button className="btn btn-warning" onClick={() => openAPIModal()}>Add API</button>
                    </div>
                    {dataLoaded ? data.api_list.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading />}
                </div>
            </div>
        </div>
    )
}

export default APIList